<template>
  <div class="search-form">
    <div class="search-form__content">
      <form
        class="search-form__form"
        @submit.prevent="handleSearch"
      >
        <label for="search" class="screen-reader-only">Search</label>
        <input
          id="search"
          ref="primaryInput"
          v-model.trim="innerValue"
          name="search"
          :placeholder="$i18n('search')"
          spellcheck="false"
          type="search"
          class="search-form__input input input--borderless"
          @input="handleChange"
        >
        <button
          type="submit"
          class="search-form__btn search-form__btn--submit"
        >
          <SearchIcon
            class="icon search-form__icon"
          />
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import SearchIcon from 'beisheim/assets/images/icons/beisheim-stiftung-search.svg'

export default {
  components: {
    SearchIcon
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    value (val) {
      this.innerValue = val
    }
  },
  methods: {
    search () {
      if (this.innerValue && this.innerValue.length) {
        this.$emit('change', this.innerValue)
      }
    },
    handleSearch () {
      this.search()
    },
    handleChange: debounce(function () { this.search() }, 200)
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/font-sizes';
@import '~beisheim/scss/scale';
@import '~beisheim/scss/font';

$container: '.search-form';

.search-form {
  display: block;
  background-color: white;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;

  &__content {
  }

  &__form {
    display: block;
    position: relative;
  }

  &__suggestions {
    position: absolute;
    z-index: 1;
    background-color: white;
    width: 100%;
    left: 0;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
  }

  &__suggestions-hint {
    padding: {
      top: 2px;
      bottom: 2px;
    }
  }

  &__suggestions-list {
    list-style: none;
    width: 100%;
  }

  &__suggestions-list-link {
    padding: 10px;
    position: relative;
    display: block;

    &, &:hover, &:focus, &:visited, &:active {
      color: black;
    }

    & em {
      font-style: normal;
      color: color(black);
    }
  }

  &__suggestions-list-item--selected #{$container}__suggestions-list-link {
  }

  &__icon {
    // taken from .rightnav__icon …
    width: 80px;
    height: auto;
  }

  /* clears the 'X' from Internet Explorer */
  input[type=search]::-ms-clear {  display: none; width : 0; height: 0; }
  input[type=search]::-ms-reveal {  display: none; width : 0; height: 0; }

  /* clears the 'X' from Chrome */
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }

  &__input {
    width: 100%;
    font-size: font-size(1);
    background: #F2F2F2;
    padding: scale(6) scale(10) scale(5) scale(10);
    border-radius: scale(10);
    font-weight: normal;
    font-family: 'HelveticaNeueLTPro-Lt', "Helvetica Neue", Arial, Helvetica, sans-serif;
    font-weight: 100;
    color: #000;
    border: 0;
    outline: 0;
    -webkit-appearance: none;

    &,
    &:hover,
    &:focus {
      background-color: #F2F2F2;
    }
  }

  &__btn {
    display: block;
    position: absolute;
    right: scale(4);
    opacity: .75;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: transparent;

    &:hover,
    &:focus,
    &:active {
      color: black;
      background-color: transparent;
      border: 0;
      outline: 0;
      cursor: pointer;
    }
  }
}
</style>
